
















import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import { employeeApis, Employee, EmployeeQuery } from '@/api';
import * as _ from 'lodash';

@Component
export default class EmployeeSelect extends Vue {
  @Prop({ required: true }) value!: number;
  @Prop({ default: false }) focus!: boolean;
  @Prop({ default: 'true' }) exist!: string;
  @Ref('employee-select') employeeSelect!: any;
  employees: Array<Employee> = [];
  localValue = -1;
  debounceSearch!: (name: string) => void;
  loading = false;

  created() {
    this.debounceSearch = _.debounce(this.remoteSearch, 150);
    this.localValue = this.value;
    if (this.localValue > 0) {
      this.search({ id: this.localValue });
    }
  }

  mounted() {
    if (this.focus) {
      this.employeeSelect.focus();
    }
  }

  private search(query: EmployeeQuery) {
    this.loading = true;
    employeeApis
      .search(query)
      .then(employees => {
        for (const emp of employees) {
          (emp as any).value = emp.username;
          (emp as any).title = this.employeeTitle(emp);
        }
        this.employees = employees;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  async remoteSearch(value: string) {
    this.search({ name: value, exist: this.exist });
  }

  @Watch('localValue')
  valueChange() {
    this.$emit('input', this.localValue);
  }

  employeeTitle(e: Employee): string {
    let result = e.display_name;
    if (e.position) {
      result += ` - ${e.position}`;
    }
    return result;
  }
}
